import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {
  baseStyles,
  BORDER_RADIUS,
  FIELD_SPACE,
  FIELD_SPACE_XS,
  IMAGE_BORDER_RADIUS,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import Space from "../commons/Space";
import {Button, Chip, Typography} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import ValueHelper, {getInitialFiles, textFieldIntegerOnKeyDown} from "../../utils/ValueHelper";
import constants from "../../constants";
import FileHelper from "../../utils/FileHelper";
import FormControl from "@material-ui/core/FormControl";
import {cloneDeep, map} from "lodash";
import InputLabel from "@material-ui/core/InputLabel";
import {
  ColorActivityForm,
  ColorBackground,
  ColorButtonSelected,
  ColorButtonSelectedHover,
  ColorCardField,
  ColorCardFieldHover,
  ColorCardFieldSelected,
  ColorNegative,
  ColorSecondary,
  ColorSeparator,
  ColorTheme, ColorTitle,
  ColorWhite
} from "src/styles/Colors";
import SingleFilePicker, {
  ACCEPTED_IMAGE_MIMES,
  ACCEPTED_VIDEO_MIMES,
  FILE_TYPE_IMAGE,
  FILE_TYPE_VIDEO,
  REWARD_IMAGE_MAX_WIDTH_HEIGHT
} from "../commons/SingleFilePicker";
import TextView from "../commons/TextView";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {ImageIcon, SNACKBAR_AUTO_HIDE_DURATION} from "src/js/components/commons/ViewHelper";
import SectionHeaderView from "src/js/components/commons/SectionHeaderView";
import FieldSpace from "src/js/components/commons/FieldSpace";
import MediaPlaceholder from "src/js/components/commons/MediaPlaceholder";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import {logDebug} from "src/js/utils/AppLog";
import FormHelperText from "@material-ui/core/FormHelperText";
import {getActivityDefaultImageUrl} from "src/js/utils/services";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Switch from "@material-ui/core/Switch";
import {fetchActivityWinRewards} from "src/js/actions/activitiesActions";
import AutoCompleteView from "src/js/components/commons/AutoCompleteView";
import {showSnackbar} from "src/js/actions/uiActions";

const useStyles = (theme) => ({
  viewVouchersListField: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  viewRewardsListError: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    // backgroundColor: ColorFieldDisabled,
    borderRadius: BORDER_RADIUS,
    border: '1px solid red'
  },
  viewVouchersError: {
    margin: -8,
    padding: 8,
    paddingTop: 10,
    paddingBottom: 10,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: ColorActivityForm,
    borderRadius: BORDER_RADIUS,
    border: '1px solid red'
  },
  boxesCardReward: {
    position: 'relative',
    display: 'flex',
    // flex: 1,
    width: '100%',
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    justifyContent: 'flex-start',
    border: '1px solid rgba(0,0,0,0.05)',
    backgroundColor: ColorCardField,
    '&:hover': {
      backgroundColor: ColorCardFieldHover,
    },
    margin: 12,
    // minHeight: 110,
    minHeight: 48,
    [theme.breakpoints.down('xs')]: {
      margin: 6,
    },
  },
  boxesCardRewardDisabled: {
    position: 'relative',
    display: 'flex',
    // flex: 1,
    width: '100%',
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    justifyContent: 'flex-start',
    border: '1px solid rgba(0,0,0,0.05)',
    backgroundColor: ColorCardField,
    margin: 12,
    // minHeight: 110,
    minHeight: 48,
    opacity: 0.6,
    [theme.breakpoints.down('xs')]: {
      margin: 6,
    },
  },
  boxesCardRewardSelected: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
    border: '2px solid '+ ColorTheme,
    backgroundColor: ColorCardFieldSelected,
    overflow: 'hidden',
    margin: 12,
    // minHeight: 110,
    minHeight: 48,
    [theme.breakpoints.down('xs')]: {
      border: '1px solid '+ ColorTheme,
      margin: 6,
    },
  },
  boxesCardButton: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    justifyContent: 'flex-start',
    width: '100%',
    // flex: 1,
    margin: 10,
    [theme.breakpoints.down('xs')]: {
      margin: 6,
    }
  },
  boxesCardButtonContent: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    justifyContent: 'flex-start',
    border: '1px solid rgba(0,0,0,0.05)',
    backgroundColor: ColorCardField,
    '&:hover': {
      backgroundColor: ColorCardFieldHover,
    },
  },
  boxContent: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    justifyContent: 'center',
    padding: 12,
    [theme.breakpoints.only('sm')]: {
      minWidth: 180,
      marginLeft: -4,
      marginRight: -4,
    },
    [theme.breakpoints.up('md')]: {
      minWidth: 200,
    }
  },
  boxContentDD: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    justifyContent: 'center',
    padding: 8,
  },
  boxContentButton: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 8,
    paddingRight: 8,
    minHeight: 48,
    backgroundColor: ColorCardField,
    '&:hover': {
      backgroundColor: ColorCardFieldHover,
    },
  },
  boxContentButtonSelected: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 8,
    paddingRight: 8,
    minHeight: 48,
    [theme.breakpoints.down('xs')]: {
      border: '1px solid '+ ColorTheme,
      margin: 8,
    },
  },
  boxContentButtonDisabled: {
    display: 'flex',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 8,
    paddingRight: 8,
    opacity: 0.6,
    minHeight: 48,
  },
  campaignImagePickerPlaceholder: {
    width: 88,
    height: 50,
    borderRadius: IMAGE_BORDER_RADIUS,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  selectedColorButton: {
    color: ColorTheme,
    backgroundColor: ColorButtonSelected,
    border: '1px solid '+ ColorTheme,
    '&:hover': {
      backgroundColor: ColorButtonSelectedHover,
    },
  },
  whiteSecondaryColorButton: {
    color: ColorSecondary,
    backgroundColor: ColorWhite,
    border: '1px solid '+ ColorSecondary,
    '&:hover': {
      backgroundColor: '#EEEEEE',
    },
  },
});

const CHALLENGE_WINNERS_BY = [
  {'id': 0, 'name': <FormattedMessage id='activity.winnersByRandom'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.winnersByTopViewed'/>},
  {'id': 2, 'name': <FormattedMessage id='activity.winnersByTopLiked'/>},
  {'id': 3, 'name': <FormattedMessage id='activity.winnersByDownloadedOnly'/>},
];

class ManageActivityRewards extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;
    this.key = 0;

    this.minOfferValidity = 0;
    this.offerValidity = 0;
    if (activityData.activityConfigs) {
      this.minOfferValidity = activityData.activityConfigs.minOfferValidity;
      this.offerValidity = activityData.activityConfigs.offerValidity;
    }

    this.enableLoyaltyReward = activityData.usageType === constants.activity.usageTypes.LOYALTY;
    this.disableWinLimit = activityData.type === constants.activity.types.EVENT
      || activityData.type === constants.activity.types.SOCIAL_CONTENT;
    this.enableWinGLimit = !this.disableWinLimit && (activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.EXTERNAL_GAMES)
      && activityData.consumeLimitPerDay > 0;
    this.enableSlotValues = activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.GUESS
      || activityData.type === constants.activity.types.VISITOR_OPINION
      || activityData.type === constants.activity.types.QUESTION
      || activityData.type === constants.activity.types.QUESTIONNAIRE
      || activityData.type === constants.activity.types.SURVEY
      || activityData.type === constants.activity.types.SOCIAL_CONTENT
      || activityData.type === constants.activity.types.CHALLENGE
      || activityData.type === constants.activity.types.PREDICTION
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.EXTERNAL_GAMES;

    if (activityData.rewardState === constants.activity.state.ACTIVE) {
      if (!activityData.winLimit && activityData.winLimit !== 0) {
        activityData.winLimit = constants.activity.VALUE_DEFAULT_MAX;
      }
      if (!activityData.winGLimit && activityData.winGLimit !== 0) {
        activityData.winGLimit = constants.activity.VALUE_DEFAULT_MAX;
      }
    }

    this.slotMinValues = 0;
    this.slotMaxValues = 0;
    this.maxWinOffersCount = 1; // set to 1 only
    if (activityData.activityConfigs) {
      this.slotMinValues = activityData.activityConfigs.slotMinValues;
      this.slotMaxValues = activityData.activityConfigs.slotMaxValues;
      // this.maxWinOffersCount = activityData.activityConfigs.maxWinOffersCount;
    }
    this.slotValues = [];
    if (this.enableSlotValues) {
      if (activityData.slotValues) {
        activityData.slotValues.forEach((option) => {
          if (activityData.rewardState === constants.activity.state.ACTIVE) {
            if (!option.winLimit && option.winLimit !== 0) {
              option.winLimit = constants.activity.VALUE_DEFAULT_MAX;
            }
          }
          option.winLimit = option.winLimit ? ''+ option.winLimit : '0';
          option.points = option.points ? ''+ option.points : '0';
          option.value1 = option.value1 ? ''+ option.value1 : '0';

          this.slotValues.push({
            id: option.id,
            number: option.number,
            imageUrl: option.imageUrl,
            imageFiles: option.imageFiles,
            isImageDeleted: option.isImageDeleted,
            offers: !this.enableLoyaltyReward ? option.offers : null,
            points: this.enableLoyaltyReward ? option.points : '0',
            value1: option.value1,
            winLimit: option.winLimit,
            winILimit: option.winILimit,
            state: option.state,
          });
        });
      } else {
        activityData.slotValues = [];
      }
      this.addDummySlotValues();
    }

    let rewardsData = null;
    if (this.enableSlotValues) {
      const firstSlot = this.slotValues[0];
      if (firstSlot && firstSlot.offers) {
        firstSlot.offers.forEach((offer) => {
          if (!offer.business) {
            offer.business = activityData.business;
          }
        });
      }
      rewardsData = cloneDeep(this.slotValues[0]);
      rewardsData.winPoints = rewardsData.points;
    } else {
      rewardsData = {
        winLimit: activityData.winLimit,
        winPoints: activityData.winPoints,
        offers: null,
      };
      if (activityData.offer) {
        if (!activityData.offer.business) {
          activityData.offer.business = activityData.business;
        }
        rewardsData.offers = [activityData.offer];
      }
    }
    rewardsData.winGLimit = activityData.winGLimit;
    if (this.enableLoyaltyReward) {
      rewardsData.offers = activityData.loyaltyRewards;
    }

    let rewardState = activityData.rewardState;
    if (!activityData.isRewardStateUpdated) {
      rewardState = constants.activity.state.ACTIVE;
      // let effWinLimit = rewardsData.winLimit;
      // if (activityData.type === constants.activity.types.EVENT
      //   || activityData.type === constants.activity.types.CHALLENGE
      //   || activityData.type === constants.activity.types.SOCIAL_CONTENT) {
        if ((!rewardsData.offers || rewardsData.offers.length === 0) && (!rewardsData.winPoints || rewardsData.winPoints == 0)) {
          rewardState = constants.activity.state.DELETE;
        }
      // } else {
      //   if (effWinLimit && effWinLimit !== '' && ValueHelper.getEnglishValue(effWinLimit) <= 0) {
      //     rewardState = constants.activity.state.DELETE;
      //   }
      // }
    }
    if (rewardState === constants.activity.state.DELETE) {
      rewardsData.winLimit = 0;
    }

    this.winnersByOptions = null;
    let winnersBySelected = null;
    if (activityData.type === constants.activity.types.CHALLENGE) {
      this.winnersByOptions = CHALLENGE_WINNERS_BY;

      winnersBySelected = null;
      this.winnersByOptions.forEach((typeObj) => {
        if (activityData.winnersBy == typeObj.id) {
          winnersBySelected = typeObj;
        }
      });
      if (!winnersBySelected) {
        winnersBySelected = this.winnersByOptions[0];
      }
    }

    let inReward = activityData.inReward;
    if (!inReward && rewardsData && rewardsData.offers && rewardsData.offers.length > 0) {
      inReward = rewardsData.offers[0];
    }
    if (inReward) {
      inReward.mediaUrl = inReward.videoUrl || (inReward.imageUrl && inReward.imageUrl != getActivityDefaultImageUrl(constants.activity.types.OFFER) ? inReward.imageUrl : null);
      inReward.mediaFiles = inReward.videoFiles || inReward.imageFiles;
      inReward.mediaType = inReward.videoUrl || (inReward.videoFiles && inReward.videoFiles.length > 0) ? FILE_TYPE_VIDEO : FILE_TYPE_IMAGE;
      inReward.mediaTUrl = inReward.videoTUrl;
      inReward.isMediaDeleted = inReward.isVideoDeleted || inReward.isImageDeleted;
      inReward.initialMediaFiles = getInitialFiles(inReward.mediaFiles, inReward.mediaUrl, inReward.mediaType, inReward.mediaTUrl);
      if (inReward.isVoucher) {
        inReward.type = constants.activity.types.VOUCHER;
        if (inReward.noVCodes) {
          inReward.noVoucherCodes = true;
        }
        if (inReward.vouchers && inReward.vouchers.length > 0) {
          inReward.aVouchers = [];
          inReward.rVouchers = [];
          inReward.vouchers.forEach((voucher) => {
            const voucherC = {
              id: voucher.id,
              code: voucher.pin ? voucher.code + ' [PIN: ' + voucher.pin + ']' : voucher.code,
              quantity: voucher.quantity,
              quantityAssigned: voucher.quantityAssigned,
              quantityGenerated: voucher.quantityGenerated,
            }
            if (voucher.id > 0 && voucher.quantityAssigned >= voucher.quantity) {
              inReward.rVouchers.push(voucherC);
            } else {
              inReward.aVouchers.push(voucherC);
            }
          });
        }
      }
    }
    let referralRewardSame = false;
    if (activityData.referralWinFunId && inReward && inReward.id === activityData.referralWinFunId) {
      referralRewardSame = true;
    }

    logDebug('rewardState-here', rewardState);

    // this.rewardOption0 = {'id': 0, 'name': <FormattedMessage id='activity.manage.noRewards'/>, 'details': <FormattedMessage id='activity.manage.noRewardsM'/>};
    this.rewardOption0 = {'id': 0, 'subId': 0, 'name': <FormattedMessage id='activity.withoutRewards'/>};
    // this.rewardOption1 = {'id': 1, 'name': <FormattedMessage id='activity.manage.selectRewards'/>, 'details': <FormattedMessage id='activity.manage.selectRewardsM'/>};
    this.rewardOption2 = {'id': 1, 'subId': constants.activity.types.OFFER, 'name': <FormattedMessage id='activity.type.offer'/>};
    // this.rewardOption3 = {'id': 1, 'subId': constants.activity.types.VOUCHER, 'name': <FormattedMessage id='activity.type.voucher'/>};
    this.rewardOption3 = {'id': 1, 'subId': constants.activity.types.VOUCHER, 'name': <FormattedMessage id='activity.type.offer'/>};

    this.state = {
      rewardState: rewardState,
      inReward: inReward,
      inRewardError: null,
      isNewRewardAdded: false,
      rewardsData: rewardsData,
      winGLimit: rewardsData.winGLimit ? (rewardsData.winGLimit != constants.activity.VALUE_DEFAULT_MAX ? ''+ rewardsData.winGLimit : '') : '0',
      winLimit: rewardsData.winLimit ? (rewardsData.winLimit != constants.activity.VALUE_DEFAULT_MAX ? ''+ rewardsData.winLimit : '') : '0',
      winPoints: this.enableLoyaltyReward && rewardsData.winPoints ? rewardsData.winPoints : '',
      referralRewardSame: referralRewardSame,
      activityRewarded: null,
      activityRewardedSearch: '',
      isActivityRewardedLoading: false,
      winnersBySelected: winnersBySelected,
      winnersByValue: activityData.winnersByValue || '0',
      showValidationMsg: false,
      rewardOptions: this.getRewardOptions(rewardsData),
      inCopyReward: false,
      inCopyRewardSearch: '',
      inCopyRewardedLoading: false,
      reload: false,
    };
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
    if (!this.props.activityData.isRewardStateUpdated) {
      this.props.onDataUpdated(this.getData(true));
    }
  }

  highlightErrors = () => {
    this.getData();
  }

  updateState(fields, onDone) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
      if (onDone) {
        onDone();
      }
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false});
  }

  getRewardOptions(rewardsData) {
    const rewardOptions = [];
    if (!this.enableLoyaltyReward) {
      rewardOptions.push(this.rewardOption0);
    }

    let showAddOffer = true;
    let showAddVoucher = true;
    // if (showAddOffer) {
    //   rewardOptions.push(this.rewardOption2);
    // }
    if (showAddVoucher) {
      rewardOptions.push(this.rewardOption3);
    }
    return rewardOptions;
  }

  addDummySlotValues() {
    const slotCount = this.slotValues ? this.slotValues.length : 0;
    if (!this.slotValues || slotCount < this.slotMaxValues) {
      if (!this.slotValues) {
        this.slotValues = [];
      }
      for (let i = 0; i < this.slotMaxValues - slotCount; i++) {
        this.slotValues.push({
          imageUrl: null,
          initialFiles: [],
          offers: [],
          points: '0',
          value1: '0',
          winLimit: '0',
          winILimit: '0',
        });
      }
    }
  }

  getData(excludeError) {
    const {activityData} = this.props;
    let {
      rewardState,
      rewardsData,
      inReward,
      winGLimit,
      winLimit,
      winPoints,
      winnersBySelected,
      winnersByValue,
      referralRewardSame
    } = this.state;
    if (rewardsData) {
      rewardsData.offers = null;
    }
    if (inReward) {
      inReward.isVideoDeleted = false;
      inReward.isImageDeleted = false;
      inReward.videoFiles = null;
      inReward.imageFiles = null;
      if (!inReward.mediaUrl) {
        inReward.videoUrl = null;
        inReward.imageUrl = null;
        inReward.isVideoDeleted = true;
        inReward.isImageDeleted = true;
      }
      if (inReward.mediaFiles && inReward.mediaFiles.length > 0) {
        if (inReward.mediaFiles[0].type === FILE_TYPE_VIDEO) {
          inReward.videoFiles = inReward.mediaFiles;
        } else {
          inReward.imageFiles = inReward.mediaFiles;
        }
      }
      if (rewardsData) {
        rewardsData.offers = [inReward];
      }
    }

    if (!excludeError) {
      if (this.enableLoyaltyReward && activityData.type !== constants.activity.types.EVENT) {
        if (!winPoints || ValueHelper.getEnglishValue(winPoints) <= 0) {
          this.setState({showValidationMsg: true});
          return false;
        }
      }

      let winLimitSet = parseInt(ValueHelper.getEnglishValue(winLimit));
      const showGameWinnersBy = activityData.type === constants.activity.types.CHALLENGE;
      if (showGameWinnersBy && winnersBySelected && winnersBySelected.id === 3) {
        winLimitSet = 0;
      }
      if (rewardState === constants.activity.state.ACTIVE) {
        if (!inReward
          || !inReward.title || inReward.title.trim().length === 0
          || (!inReward.mediaUrl && (!inReward.mediaFiles || inReward.mediaFiles.length === 0))
          || (inReward.type === constants.activity.types.VOUCHER && ((inReward.noVoucherCodes && !inReward.noVCodes) || (!inReward.noVoucherCodes && (!inReward.vouchers || inReward.vouchers.length === 0 || inReward.vouchers.length < winLimitSet + (referralRewardSame ? 1 : 0)))))
          || (inReward.usageType === constants.activity.usageTypes.LOYALTY && (!inReward.fee || ValueHelper.getEnglishValue(inReward.fee) <= 0))
          || !this.areWinValuesCorrect()) {
          this.setState({showValidationMsg: true});
          return false;
        }
      }
    }

    const data = {
      rewardState,
      isRewardStateUpdated: true,
      winGLimit,
      winPoints,
      inReward,
      referralRewardSame,
      referralWinFun: referralRewardSame ? inReward : null
    };
    if (this.enableSlotValues) {
      this.slotValues.forEach((slot) => {
        slot.winLimit = winLimit;
        if (this.enableLoyaltyReward) {
          slot.offers = null;
          slot.points = winPoints;
        } else {
          slot.offers = rewardsData.offers;
          slot.points = 0;
        }
      });
    } else {
      data.winLimit = winLimit;
      if (this.enableLoyaltyReward) {
        data.offer = null;
        data.offerId = 0;
        data.winPoints = winPoints;
      } else {
        data.offer = rewardsData.offers && rewardsData.offers.length > 0 ? rewardsData.offers[0] : null;
        data.offerId = rewardsData.offers && rewardsData.offers.length > 0 ? rewardsData.offers[0].id : null;
        data.winPoints = 0;
      }
    }
    if (this.enableSlotValues) {
      data.slotValues = this.slotValues;
    }
    if (this.enableLoyaltyReward) {
      data.loyaltyRewards = rewardsData.offers;
    }
    if (activityData.type === constants.activity.types.CHALLENGE) {
      data.winnersBy = winnersBySelected ? winnersBySelected.id : 0;
      data.winnersByValue = winnersByValue;
    }
    return data;
  }

  render() {
    const {activities, activityData, app, classes, isXS} = this.props;
    const {
      rewardState,
      rewardsData,
      showValidationMsg,
      inReward,
      winGLimit,
      winLimit,
      winPoints,
      rewardOptions,
      winnersBySelected,
      winnersByValue,
      referralRewardSame,
      inCopyReward,
      inCopyRewardSearch,
      inCopyRewardedLoading,
    } = this.state;

    let showWinLimit = !this.disableWinLimit && (this.enableSlotValues
      || activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.COLLECT_STARS);

    const vouchersCount = inReward && inReward.type === constants.activity.types.VOUCHER && inReward.vouchers ? inReward.vouchers.length : 0;
    const showReferralReward = activityData.usageType === constants.activity.usageTypes.MARKETING || activityData.usageType === constants.activity.usageTypes.INFLUENCER;
    let winLimitSet = parseInt(ValueHelper.getEnglishValue(winLimit));

    const showGameWinnersBy = activityData.type === constants.activity.types.CHALLENGE;
    if (showGameWinnersBy && winnersBySelected && winnersBySelected.id === 3) {
      showWinLimit = false;
      winLimitSet = 0;
    }

    const noVoucherCodeInfoError = showValidationMsg && inReward && inReward.type === constants.activity.types.VOUCHER && inReward.noVoucherCodes && !inReward.noVCodes;
    const inRewardVoucherError = showValidationMsg && inReward && inReward.type === constants.activity.types.VOUCHER && !inReward.noVoucherCodes && (!inReward.vouchers || inReward.vouchers.length === 0);
    const inRewardLoyaltyPointsError = showValidationMsg && inReward && this.enableLoyaltyReward
      && (!inReward.fee || ValueHelper.getEnglishValue(inReward.fee) <= 0);

    const winRewardsError = showValidationMsg && (!rewardsData.offers || rewardsData.offers.length === 0);
    let winLimitErrorId = showValidationMsg && (!winLimit || winLimit.length === 0 || ValueHelper.getEnglishValue(winLimit) <= 0) ? 'activity.validation.requiredMoreThanZero' : null;
    if (showValidationMsg && !winLimitErrorId && inReward && inReward.type === constants.activity.types.VOUCHER && !inReward.noVoucherCodes && vouchersCount < ValueHelper.getEnglishValue(winLimit)) {
      winLimitErrorId = 'activity.winLimitMoreThanVouchers';
    }
    const winGLimitError = showValidationMsg && this.enableWinGLimit && (winGLimit && ValueHelper.getEnglishValue(winGLimit) <= 0);
    const mediaError = showValidationMsg && (!inReward || (!inReward.mediaUrl && (!inReward.mediaFiles || inReward.mediaFiles.length === 0)));

    const referralErrorId = showValidationMsg && referralRewardSame && inReward
      && inReward.type === constants.activity.types.VOUCHER && vouchersCount < winLimitSet + 1 ? 'activity.voucherMoreThanWinLimitForReferral' : null;

    let winPointsError = showValidationMsg && winLimit && ValueHelper.getEnglishValue(winLimit) <= 0;
    let topHintLabelId;
    let titleLoyaltyPoints;
    let hintLoyaltyPoints;
    if (activityData.type === constants.activity.types.EVENT) {
      topHintLabelId = activityData.usageType === constants.activity.usageTypes.LOYALTY ? 'activity.manage.topHintEventLoyaltyRewards' : 'activity.manage.topHintEventRewards';
      titleLoyaltyPoints = 'activity.eventPoints';
      hintLoyaltyPoints = 'activity.hintLoyaltyPointsParticipants';
    } else {
      winPointsError = showValidationMsg && (!winPoints || ValueHelper.getEnglishValue(winPoints) <= 0);
      topHintLabelId = activityData.usageType === constants.activity.usageTypes.LOYALTY ? 'activity.manage.topHintLoyaltyRewards' : 'activity.manage.topHintRewards';
      titleLoyaltyPoints = 'activity.winPoints';
      hintLoyaltyPoints = 'activity.hintLoyaltyPointsWinners';
    }
    const extraHorizontalMargin = isXS ? 0 : 12;

    const viewSeparator = (
      isXS ?
        <FieldSpace multiplier={1}/>
        :
        <React.Fragment>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', padding: FIELD_SPACE, paddingTop: 0}}>
            <div style={{display: 'flex', flex: 1, width: 1.5, backgroundColor: ColorSeparator}} />
          </div>
        </React.Fragment>
    );

    const inputSpace = FIELD_SPACE;
    return (
      <div className={classes.viewColumnFullWidthNoCenter}>
        <div className={isXS ? classes.viewColumnFullWidthNoCenter : classes.viewRowFullWidthNoCenter}>
          <div className={classes.flexColumnNoCenter}>
            {/*<SectionHeaderView labelId={'activity.manage.selectReward'}/>*/}
            {this.enableLoyaltyReward ?
              <div className={classes.viewColumnFullWidth}>
                <div className={classes.formActivitySmall}>
                  <div className={classes.viewColumnFullWidth}>
                    <TextField
                      variant="filled"
                      fullWidth
                      size="small"
                      type="number"
                      id="winPoints"
                      name="winPoints"
                      label={<FormattedMessage id={titleLoyaltyPoints} />}
                      value={winPoints}
                      InputProps={{disableUnderline: true}}
                      inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX}}
                      onChange={this.onChange}
                      onKeyDown={textFieldIntegerOnKeyDown}
                      helperText={<FormattedMessage id={winPointsError ? 'activity.enterNonZeroLoyaltyPoints' : hintLoyaltyPoints} />}
                      error={winPointsError}
                    />
                    <Space horizontal={inputSpace} />
                    {rewardState === constants.activity.state.ACTIVE ?
                      <div className={classes.viewColumnFullWidth}>
                        {showWinLimit ?
                          <div className={classes.viewColumnFullWidth}>
                            <TextField
                              variant="filled"
                              fullWidth
                              size="small"
                              type="number"
                              id="winLimit"
                              name="winLimit"
                              label={<FormattedMessage id={'activity.manage.winLimit'} />}
                              value={winLimit}
                              InputProps={{disableUnderline: true}}
                              inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX}}
                              onChange={this.onChange}
                              onKeyDown={textFieldIntegerOnKeyDown}
                              error={winLimitErrorId != null}
                              helperText={winLimitErrorId != null ? <FormattedMessage id={winLimitErrorId} /> : <FormattedMessage id='activity.manage.hintWinLimit'/>}
                            />
                            <Space horizontal={inputSpace} />
                          </div>
                          : null
                        }
                        {this.enableWinGLimit ?
                          <div className={classes.flexColumnNoCenter}>
                            <TextField
                              variant="filled"
                              fullWidth
                              size="small"
                              type="number"
                              id="winGLimit"
                              name="winGLimit"
                              label={<FormattedMessage id='activity.manage.winGLimit'/>}
                              value={winGLimit}
                              InputProps={{disableUnderline: true}}
                              inputProps={{min: 1, max: constants.activity.VALUE_DEFAULT_MAX}}
                              onChange={this.onChange}
                              onKeyDown={textFieldIntegerOnKeyDown}
                              error={winGLimitError}
                              helperText={winGLimitError ? winGLimitError : <FormattedMessage id='activity.manage.sectionHintTotalWinLimit' />}
                            />
                            <Space horizontal={inputSpace}/>
                          </div>
                          : null
                        }
                      </div>
                    : null
                    }
                  </div>
                </div>
              </div>
              :null
            }

            {!this.enableLoyaltyReward || ValueHelper.getEnglishValue(winPoints) > 0 ?
              <div className={classes.formActivity}>
                {this.enableLoyaltyReward ?
                  <div style={{flexDirection: 'column', marginTop: 5 * inputSpace, marginBottom: 16, backgroundColor: ColorBackground, borderRadius: 16, padding: 4, paddingLeft: 8, paddingRight: 8}}>
                    <Typography variant={'subtitle2'} color={'primary'} align={'center'} style={{fontWeight: 'normal'}}>
                      {<FormattedMessage id={'activity.manage.hintLoyaltyRewards2'} />}
                    </Typography>
                  </div>
                  : null
                }

                <div className={classes.viewRowFullWidth}>
                  {rewardOptions.map((item, index) => {
                    return this.getRewardOptionView(item, index);
                  })}
                </div>

                <FieldSpace multiplier={2} />

                {rewardState === constants.activity.state.ACTIVE ?
                  <div className={classes.formActivity}>
                    {inReward && inReward.type ?
                      <React.Fragment>
                        {/*{!isXS ? <MediaPlaceholder required labelId={inReward.type === constants.activity.types.VOUCHER ? 'activity.voucherMedia' : 'activity.offerMedia'}/> : null}*/}

                        {inCopyReward ?
                          <div className={classes.viewColumnFullWidth}>
                            <AutoCompleteView
                              ref={(ref) => this.refSelectRewardToCopy = ref}
                              fullWidth
                              variant="outlined"
                              label={this.context.intl.formatMessage({id: 'activity.copyReward'})}
                              placeholder={this.context.intl.formatMessage({id: 'activity.manage.searchNSelectReward'})}
                              loading={inCopyRewardedLoading}
                              options={activities.activity.data.winRewards}
                              // selectedValues={activityRewarded}
                              inputValue={inCopyRewardSearch}
                              onInputChange={this.onChangeRewardToCopySearch}
                              onSelect={this.onSelectRewardToCopy}
                              renderOption={(option) => {
                                return (
                                  <div className={classes.viewRowFullWidth} style={{minHeight: 40}}>
                                    <img style={{width: 40, height: 30, borderRadius: 4, objectFit: 'contain'}} src={option.videoTUrl || option.imageUrl} />
                                    <Space vertical={12}/>
                                    <TextView color={ColorTitle} numberOfLines={2} style={{flex: 1}}>{option.name}</TextView>
                                  </div>
                                )
                              }}
                            />
                          </div>
                          : null
                        }
                        {!inCopyReward ? <div className={classes.viewRow} style={{minHeight: 50}}>
                            <Button disabled={activityData.noRewardsPresent} fullWidth={true} size={"large"} disableElevation={true} onClick={this.toggleCopyReward} variant={'outlined'} color={'primary'}><FormattedMessage id={activityData.noRewardsPresent ? 'activity.noRewardsPresent' : 'activity.copyReward'}/></Button>
                          </div>
                          : null
                        }
                        <FieldSpace multiplier={1}/>


                        {!isXS ? <MediaPlaceholder required labelId={'activity.offerMedia'}/> : null}
                        <div className={isXS ? classes.flexRowNoCenter : classes.viewColumnFullWidthNoCenter1}>
                          <SingleFilePicker
                            key={inReward.type +'-'+ (inReward.initialMediaFiles && inReward.initialMediaFiles.length > 0 ? inReward.initialMediaFiles[0].url : '')}
                            required
                            hideDropzoneText={true}
                            size={isXS ? 'xsmall' : 'small'}
                            filesLimit={1}
                            acceptedFiles={{...ACCEPTED_IMAGE_MIMES, ...ACCEPTED_VIDEO_MIMES}}
                            maxSizeMimes={{image: 20*1024*1024, video: 100*1024*1024}}
                            maxDurationMimes={{video: activityData.mediaConfigs.maxVideoDuration}}
                            maxWidthOrHeight={REWARD_IMAGE_MAX_WIDTH_HEIGHT}
                            aspectRatio={4/3}
                            initialFiles={inReward.initialMediaFiles}
                            onChange={(files) => {
                              this.onChangeFiles(files, 'mediaUrl');
                            }}
                            onDelete={(file) => {
                              this.onDeleteFile(file, 'mediaUrl');
                            }}
                            error={mediaError}
                          />
                          {!isXS && mediaError ? <FormHelperText className={classes.helperErrorPadding}><FormattedMessage id={'activity.imageVideoRequired'}/></FormHelperText> : null}
                          <FieldSpace vertical={isXS}/>

                          <TextField
                            variant="filled"
                            fullWidth
                            required
                            size="small"
                            type="text"
                            id="title"
                            name="title"
                            // label={<FormattedMessage id={inReward.type === constants.activity.types.VOUCHER ? 'activity.manage.voucherTitle' : 'activity.manage.offerTitle'}/>}
                            label={<FormattedMessage id={'activity.manage.offerTitle'}/>}
                            InputProps={{disableUnderline: true}}
                            inputProps={{maxLength: 200}}
                            value={inReward.title}
                            onChange={this.onChangeForReward}
                            error={showValidationMsg && !inReward.title}
                            helperText={showValidationMsg && !(isXS && mediaError) && !inReward.title && <FormattedMessage id='generic.validation.required'/>}
                          />
                        </div>
                        {isXS && mediaError ? <FormHelperText className={classes.helperErrorPadding}><FormattedMessage id={!inReward.title ? 'activity.imageOrVideoTextRequired' : 'activity.imageVideoRequired'}/></FormHelperText> : null}
                        <FieldSpace/>

                        <TextField
                          multiline
                          rows={2}
                          rowsMax={isXS ? 4 : 6}
                          variant="filled"
                          fullWidth
                          size="small"
                          type="text"
                          id="description"
                          name="description"
                          // label={<FormattedMessage id='activity.manage.description'/>}
                          label={<FormattedMessage id='activity.rewardCodeDetailsPlaceholder'/>}
                          InputProps={{disableUnderline: true}}
                          inputProps={{maxLength: 2000}}
                          value={inReward.description}
                          onChange={this.onChangeForReward}
                        />
                        <FieldSpace/>

                        {activityData.usageType === constants.activity.usageTypes.LOYALTY ?
                          <React.Fragment>
                            <TextField
                              required
                              variant="filled"
                              fullWidth
                              size="small"
                              type="number"
                              id="fee"
                              name="fee"
                              label={<FormattedMessage id='activity.manage.loyaltyRewardFee'/>}
                              InputProps={{disableUnderline: true}}
                              inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX}}
                              value={inReward.fee}
                              onChange={this.onChangeForReward}
                              onKeyDown={textFieldIntegerOnKeyDown}
                              error={inRewardLoyaltyPointsError}
                              helperText={inRewardLoyaltyPointsError ? <FormattedMessage id='activity.requiredLoyaltyPointsToRedeem' /> : null}
                            />
                            <FieldSpace/>
                          </React.Fragment>
                          : null
                        }

                        {activityData.noVCodesAllowed || inReward.noVoucherCodes ?
                          <React.Fragment>
                            <div className={classes.viewRowNoCenter} style={{marginTop: isXS ? 20 : 24}}>
                              <div className={classes.viewColumn}>
                                <SectionHeaderView
                                  labelId={'activity.checkOfferVoucher'}
                                  noBottomSpace={true}/>
                              </div>
                              <Switch
                                checked={inReward.noVoucherCodes}
                                onChange={this.onCheckedNoVoucherCodes}
                                id="checkNoVoucherCodes"
                                name="checkNoVoucherCodes"
                                color="primary"
                              />
                            </div>
                          </React.Fragment>
                          : null
                        }

                        {inReward.type === constants.activity.types.VOUCHER && inReward.noVoucherCodes ?
                          <React.Fragment>
                            <FieldSpace multiplier={0.5}/>
                            <div className={classes.viewRowFullWidth}>
                              {this.getSubsRewardOptionsRadioView('activity.extraEmail', 1, 0)}
                              {this.getSubsRewardOptionsRadioView('activity.extraMobile', 2, 1)}
                            </div>
                            {noVoucherCodeInfoError ?
                              <FormHelperText className={classes.helperError}><FormattedMessage id={'activity.moreInfoTypeRequired'}/></FormHelperText>
                              : null
                            }
                          </React.Fragment>
                          : null
                        }

                        {inReward.type === constants.activity.types.VOUCHER && !inReward.noVoucherCodes ?
                          <React.Fragment>
                            <FieldSpace multiplier={2}/>
                            <SectionHeaderView labelId={'activity.manage.vouchersCodes'} subLabelId={'activity.manage.hintEnterVoucherCode'} />
                            {inReward.type === constants.activity.types.VOUCHER && (!inReward.aVouchers || inReward.aVouchers.length < 100) ?
                              <div className={classes.flexRowNoCenter}>
                                <div className={classes.flexColumn}>
                                  <TextField
                                    variant="filled"
                                    required={inReward.type === constants.activity.types.VOUCHER && (!inReward.vouchers || inReward.vouchers.length === 0)}
                                    fullWidth
                                    multiline
                                    rows={1}
                                    rowsMax={8}
                                    size="small"
                                    type="text"
                                    id="newVoucher"
                                    name="newVoucher"
                                    label={<FormattedMessage id={'activity.manage.enterVoucherCode'} />}
                                    InputProps={{disableUnderline: true}}
                                    inputProps={{maxLength: 100}}
                                    value={inReward.newVoucher}
                                    onChange={this.onChangeForReward}
                                    error={inRewardVoucherError}
                                    helperText={inRewardVoucherError ? <FormattedMessage id={'activity.manage.atleastOneVocuherNeeded'} /> : null}
                                  />
                                </div>
                                <Space vertical={12}/>
                                <div className={classes.viewColumn}>
                                  <Button
                                    disableElevation
                                    size={isXS ? 'medium' : 'large'}
                                    disabled={!inReward.newVoucher || inReward.newVoucher.trim().length === 0}
                                    variant={'outlined'}
                                    color="primary"
                                    className={classes.buttonCamelCase}
                                    // style={{minHeight: 48}}
                                    onClick={this.onAddNewVoucherClicked}>
                                    {<FormattedMessage id={'activity.manage.addCode'}/>}
                                  </Button>
                                </div>
                              </div>
                              : null
                            }
                            <Space horizontal={8}/>

                            <div className={classes.viewVouchersListField}>
                              {inReward.aVouchers && inReward.aVouchers.length > 0 ?
                                <div className={classes.viewFullWidthWrap} style={{margin: -4, marginLeft: 0, marginRight: -8, paddingLeft: 2, paddingRight: 2, paddingBottom: 4}}>
                                  {inReward.aVouchers.map((voucher, index) => {
                                    let chipName = voucher.code;
                                    return (
                                      <Chip
                                        size={'medium'}
                                        key={voucher.id}
                                        style={{minHeight: 32, marginTop: 4, marginBottom: 4, marginRight: app.isLTR ? 8 : 0, marginLeft: !app.isLTR ? 8 : 0, overflow: 'hidden', borderRadius: BORDER_RADIUS}}
                                        label={<TextView numberOfLines={1} variant={'body1'} style={{minHeight: 32, whiteSpace: 'normal', paddingTop: 6, paddingBottom: 6}}>{chipName}</TextView>}
                                        onDelete={this.onDeleteAvailableVoucher.bind(this, voucher, index)}
                                      />
                                    );
                                  })}
                                </div>
                                : null
                              }
                              {inReward.rVouchers && inReward.rVouchers.length > 0 ?
                                <React.Fragment>
                                  <FieldSpace multiplier={2}/>
                                  <SectionHeaderView labelId={'activity.consumedVouchers'} noBottomSpace={true}/>
                                  <Space horizontal={6}/>
                                  <div className={classes.viewFullWidthWrap} style={{margin: -4, marginLeft: 0, marginRight: -8, paddingLeft: 2, paddingRight: 2, paddingBottom: 4}}>
                                    {inReward.rVouchers.map((voucher, index) => {
                                      let chipName = voucher.code;
                                      return (
                                        <Chip
                                          size={'small'}
                                          key={voucher.id}
                                          style={{minHeight: 26, marginTop: 4, marginBottom: 4, marginRight: app.isLTR ? 8 : 0, marginLeft: !app.isLTR ? 8 : 0, overflow: 'hidden', borderRadius: BORDER_RADIUS}}
                                          label={<TextView numberOfLines={1} variant={'caption'} style={{minHeight: 26, whiteSpace: 'normal', paddingTop: 6, paddingBottom: 6}}>{chipName}</TextView>}
                                          onDelete={this.onDeleteRedeemVoucher.bind(this, voucher, index)}
                                        />
                                      );
                                    })}
                                  </div>
                                </React.Fragment>
                                : null
                              }
                            </div>
                            <FieldSpace />
                          </React.Fragment>
                          : null
                        }

                        {/*<Space horizontal={6}/>*/}
                        {/*{isBlockedLoading && <ProgressLoader progress={loadingProgress} />}*/}
                        {/*{showValidationMsg ? <TextView variant={'body2'} aling={'left'} color={ColorNegative} style={{alignSelf: 'flex-start'}}>{inRewardErrorEff}</TextView> : null}*/}
                        <FieldSpace/>
                      </React.Fragment>
                      : null
                    }
                  </div>
                  : winRewardsError ? <TextView variant={'body2'} aling={'left'} color={ColorNegative} style={{alignSelf: 'flex-start', marginBottom: 8, marginTop: isXS ? -FIELD_SPACE_XS : -FIELD_SPACE}}>{<FormattedMessage id={this.enableLoyaltyReward ? 'activity.manage.atleastOneLoyaltyRewardNeeded' : 'activity.manage.atleastOneRewardNeeded'} />}</TextView>
                    : null
                }
              </div>
              : null
            }
          </div>

          {inReward ?
            <React.Fragment>
              {viewSeparator}
              {!this.enableLoyaltyReward && (showWinLimit || this.enableWinGLimit || showGameWinnersBy) ?
                <div className={classes.viewColumnFullWidthNoCenter}>
                  <SectionHeaderView labelId={'activity.setWinnersLimit'}/>
                  <div className={classes.formActivity}>
                    {showGameWinnersBy ?
                      <React.Fragment>
                        <FormControl
                          disabled={!rewardsData.offers || rewardsData.offers.length === 0}
                          size="small"
                          fullWidth
                          variant="filled">
                          <InputLabel id="dropDown"><FormattedMessage id={'activity.winnersBy'} /></InputLabel>
                          <Select
                            disabled={!rewardsData.offers || rewardsData.offers.length === 0}
                            labelId="dropDown"
                            required
                            id="winnersBySelected"
                            name="winnersBySelected"
                            value={winnersBySelected}
                            disableUnderline={true}
                            onChange={this.onChange}>
                            {map(this.winnersByOptions, (type) => {
                              return (
                                <MenuItem key={type.id} value={type}>{type.name}</MenuItem>
                              )
                            })}
                          </Select>
                        </FormControl>
                        <FieldSpace />
                      </React.Fragment>
                      : null
                    }

                    {showGameWinnersBy && winnersBySelected && winnersBySelected.showWinnersByValue ?
                      <React.Fragment>
                        <TextField
                          disabled={!rewardsData.offers || rewardsData.offers.length === 0}
                          variant="outlined"
                          fullWidth
                          size="small"
                          type="number"
                          id="winnersByValue"
                          name="winnersByValue"
                          label={<FormattedMessage id={'activity.manage.minValueToWinEligible'} />}
                          value={winnersByValue}
                          inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX}}
                          onChange={this.onChange}
                        />
                        <FieldSpace />
                      </React.Fragment>
                      : null
                    }
                    {showWinLimit ?
                      <React.Fragment>
                        <TextField
                          disabled={!rewardsData.offers || rewardsData.offers.length === 0}
                          variant="filled"
                          fullWidth
                          size="small"
                          type="number"
                          id="winLimit"
                          name="winLimit"
                          label={<FormattedMessage id={'activity.manage.winLimit'} />}
                          value={winLimit}
                          InputProps={{disableUnderline: true}}
                          inputProps={{min: 0, max: constants.activity.VALUE_OFFER_MAX_IN_CAMPAIGN}}
                          onChange={this.onChange}
                          error={rewardsData.offers && rewardsData.offers.length > 0 && winLimitErrorId != null}
                          // helperText={winLimitErrorId != null ? <FormattedMessage id={winLimitErrorId} /> : <FormattedMessage id='activity.manage.hintWinLimit'/>}
                          helperText={(rewardsData.offers && rewardsData.offers.length > 0) ? <FormattedMessage id={winLimitErrorId != null ? winLimitErrorId : 'activity.voucherMinMaxLimit'} /> : null}
                        />
                        <FieldSpace />
                      </React.Fragment>
                      : null
                    }
                    {showReferralReward ?
                      <React.Fragment>
                        <FieldSpace />
                        <SectionHeaderView labelId={'activity.referralReward'} noBottomSpace={true}/>
                        <Space horizontal={2}/>
                        <FormControl>
                          <FormGroup>
                            <FormControlLabel
                              style={{marginLeft: -8, alignItems: 'flex-start'}}
                              control={
                                <Checkbox
                                  size={'medium'}
                                  icon={<ImageIcon src={require('src/images/ic_square.png')} width={20} height={20} />}
                                  checkedIcon={<ImageIcon src={require('src/images/ic_square_check.png')} width={20} height={20} />}
                                  checked={referralRewardSame} onChange={this.onToggleReferralReward} />
                              }
                              label={<div style={{display: 'flex', flexDirection: 'column', marginTop: 8}}>
                                <Typography variant="body2">
                                  <FormattedMessage id='activity.referralManageHint' />
                                </Typography>
                              </div>}
                            />
                          </FormGroup>
                        </FormControl>
                        {referralErrorId ? <FormHelperText className={classes.helperErrorPadding}><FormattedMessage id={referralErrorId}/></FormHelperText> : null}
                        <FieldSpace />
                      </React.Fragment>
                      : null
                    }
                  </div>
                </div>
                :null
              }
            </React.Fragment>
            : null
          }
        </div>
        {this.renderSnackBar()}
      </div>
    );
  }

  renderSnackBar() {
    const {snackbarMessageId, snackbarType} = this.state;
    const onClose = () => {
      this.setState({snackbarMessageId: null, snackbarType: null});
    };
    return (
      <Snackbar open={snackbarMessageId != null} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
        <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled">
          {snackbarMessageId ? <FormattedMessage id={snackbarMessageId} /> : null}
        </MuiAlert>
      </Snackbar>
    );
  }

  showSnackbar(messageId) {
    this.setState({
      snackbarMessageId: messageId,
      snackbarType: 'success'
    });
  }

  getRewardOptionView(item, index) {
    const onClick = () => {
      const {activityData} = this.props;
      const {rewardState, rewardsData, inReward} = this.state;
      if ((!item.id && inReward) || rewardState !== item.id || !inReward || inReward.type !== item.subId) {
        rewardsData.offers = null;
        let newInReward = null;
        if (item.id) {
          const type = item.subId;
          newInReward = {
            type: type,
            usageType: activityData.usageType === constants.activity.usageTypes.LOYALTY ? activityData.usageType : 0,
            endInDay: this.offerValidity,
            fee: '',
            title: '',
            description: '',
            imageUrl: null,
            initialFiles: [],
            consumableAt: type === constants.activity.types.VOUCHER ? 10 : 0,
            isVoucher: type === constants.activity.types.VOUCHER,
          };
          if (type === constants.activity.types.VOUCHER) {
            newInReward.newVoucher = '';
            newInReward.vouchers = [];
          }
          rewardsData.offers = [newInReward];
        }
        this.updateState({
          rewardState: item.id,
          rewardsData: rewardsData,
          inReward: newInReward,
          winLimit: winLimit && parseInt(ValueHelper.getEnglishValue(winLimit)) > 0 ? winLimit : 1,
          winGLimit: '',
          showValidationMsg: false,
        });
      }
    };

    const {classes, app} = this.props;
    const {inReward, winLimit} = this.state;
    const isSelected = item.id === this.state.rewardState && (!item.subId || (inReward && item.subId === inReward.type));
    const margin = index > 0 ? 12 : 0;
    return (
      <Button
        fullWidth={true}
        key={item.id +'-'+ item.subId}
        color={isSelected ? 'primary' : 'secondary'}
        size={this.props.isXS ? 'medium' : 'large'}
        variant={"outlined"}
        onClick={onClick}
        style={{marginRight: !app.isLTR ? margin : 0, marginLeft: app.isLTR ? margin : 0}}
        className={isSelected ? classes.selectedColorButton : classes.whiteSecondaryColorButton}
        startIcon={isSelected ? <ImageIcon src={require('src/images/ic_checked.png')} /> : null}>
        <FormattedMessage id={item.name} />
      </Button>
    );
  }

  onToggleReferralReward = () => {
    this.updateState({
      referralRewardSame: !this.state.referralRewardSame,
      showValidationMsg: false
    });
  }

  onAddNewVoucherClicked = () => {
    const {inReward} = this.state;
    let {vouchers, aVouchers, newVoucher} = inReward;
    if (newVoucher && newVoucher.trim().length > 0) {
      if (!vouchers) {
        vouchers = [];
      }
      if (!aVouchers) {
        aVouchers = [];
      }

      const newVoucherCopy = {
        id: -(new Date().getMilliseconds()),
        code: newVoucher.trim(),
        quantity: 1,
      };
      inReward.newVoucher = '';
      vouchers.splice(0, 0, newVoucherCopy);
      aVouchers.splice(0, 0, newVoucherCopy);
      inReward.vouchers = vouchers;
      inReward.aVouchers = aVouchers;
    }
    this.updateState({inReward, newVoucher: '', showValidationMsg: false});
  };

  onDeleteAvailableVoucher = (voucher, index) => {
    const {inReward} = this.state;
    const {vouchers, aVouchers} = inReward;
    let {deleteVoucherIds} = inReward;
    if (!deleteVoucherIds) {
      deleteVoucherIds = [];
    }
    if (voucher.id && voucher.id > 0) {
      deleteVoucherIds.push(voucher.id);
    }
    aVouchers.splice(index, 1);

    let vIndex = -1;
    let count = 0;
    vouchers.forEach((voucherL) => {
      if (voucherL.id === voucher.id) {
        vIndex = count;
      }
      count++;
    });
    if (vIndex >= 0) {
      vouchers.splice(vIndex, 1);
    }
    inReward.vouchers = vouchers;
    inReward.aVouchers = aVouchers;
    inReward.deleteVoucherIds = deleteVoucherIds;
    this.updateState({inReward, showValidationMsg: false});
  };

  onDeleteRedeemVoucher = (voucher, index) => {
    const {inReward} = this.state;
    const {vouchers, rVouchers} = inReward;
    let {deleteVoucherIds} = inReward;
    if (!deleteVoucherIds) {
      deleteVoucherIds = [];
    }
    if (voucher.id && voucher.id > 0) {
      deleteVoucherIds.push(voucher.id);
    }
    rVouchers.splice(index, 1);

    let vIndex = -1;
    let count = 0;
    vouchers.forEach((voucherL) => {
      if (voucherL.id === voucher.id) {
        vIndex = count;
      }
      count++;
    });
    if (vIndex >= 0) {
      vouchers.splice(vIndex, 1);
    }
    inReward.vouchers = vouchers;
    inReward.rVouchers = rVouchers;
    inReward.deleteVoucherIds = deleteVoucherIds;
    this.updateState({inReward, showValidationMsg: false});
  };

  onChangeFiles(files, id) {
    let {inReward} = this.state;
    const {mediaUrl} = inReward;

    let eImageUrl = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    if (id === 'mediaUrl') {
      eImageUrl = mediaUrl;
      keyImageUrl = 'mediaUrl';
      keyImageFiles = 'mediaFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eImageUrl)) {
          lFileUrl = eImageUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    inReward[keyImageUrl] = lFileUrl;
    inReward[keyImageFiles] = lFiles;
    inReward.copyImageUrl = null;
    inReward.copyVideoUrl = null;
    inReward.copyVideoStreamUrl = null;
    this.updateState({showValidationMsg: false, inReward});
  }

  onDeleteFile(file, id) {
    let {inReward} = this.state;
    const {mediaUrl, mediaFiles} = inReward;

    let eImageUrl = null;
    let eImageFiles = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    let keyIsImageDeleted = null;
    if (id === 'mediaUrl') {
      eImageUrl = mediaUrl;
      eImageFiles = mediaFiles;
      keyImageUrl = 'mediaUrl';
      keyImageFiles = 'mediaFiles';
      keyIsImageDeleted = 'isMediaDeleted';
    }

    let lFiles = [];
    let lFileUrl = eImageUrl;
    if (eImageFiles) {
      eImageFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
      });
      lFiles = eImageFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eImageUrl)) {
      lFileUrl = null;
    }

    inReward[keyImageUrl] = lFileUrl;
    inReward[keyImageFiles] = lFiles;
    inReward[keyIsImageDeleted] = true;
    inReward.copyImageUrl = null;
    inReward.copyVideoUrl = null;
    inReward.copyVideoStreamUrl = null;
    this.updateState({showValidationMsg: false, inReward});
  }

  areWinValuesCorrect() {
    const {winLimit, winGLimit, rewardsData, winnersBySelected} = this.state;
    if (!this.disableWinLimit) {
      if (this.enableWinGLimit) {
        if (winGLimit && ValueHelper.getEnglishValue(winGLimit) <= 0) {
          return false;
        }
      }
      let isWinLimitCheckRequired = true;
      if (this.props.activityData.type === constants.activity.types.CHALLENGE && winnersBySelected && winnersBySelected.id === 3) {
        isWinLimitCheckRequired = false;
      }
      if (isWinLimitCheckRequired && (!winLimit || winLimit.length === 0 || ValueHelper.getEnglishValue(winLimit) <= 0)) {
        return false;
      }
    }
    return rewardsData.offers && rewardsData.offers.length > 0;
  }

  onChange = (event) => {
    const {rewardState, winPoints, winLimit, winGLimit, rewardsData} = this.state;
    let rewardStateEff = rewardState;
    let winLimitEff = winLimit;
    let winGLimitEff = winGLimit;
    let value = event.target.value;
    if (event.target.name === 'winPoints'
      || event.target.name === 'winLimit'
      || event.target.name === 'winGLimit'
    ) {
      let maxValue = constants.activity.VALUE_DEFAULT_MAX;
      if (event.target.name === 'winLimit') {
        maxValue = constants.activity.VALUE_OFFER_MAX_IN_CAMPAIGN;
      }
      value = ValueHelper.getDecimalValue(value);
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = 0;
      } else if (ValueHelper.getEnglishValue(value) > maxValue) {
        value = maxValue;
      }
      if (!value && value !== 0) {
        value = '';
      }
      if (event.target.name === 'winLimit') {
        winLimitEff = value;
      } else if (event.target.name === 'winGLimit') {
        winGLimitEff = value;
      }
      if (event.target.name === 'winPoints') {
        if (value > 0) {
          rewardStateEff = constants.activity.state.ACTIVE;
          if (!winPoints || winPoints <= 0) {
            winLimitEff = '';
            winGLimitEff = '';
          }
        } else {
          rewardStateEff = constants.activity.state.INACTIVE;
          winLimitEff = '';
          winGLimitEff = '';
        }
      }
    } else if (event.target.name === 'resetGameDays' || event.target.name === 'winnersByValue') {
      let maxValue = constants.activity.VALUE_DEFAULT_MAX;
      if (event.target.name === 'resetGameDays') {
        maxValue = 365;
      }
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = 0;
      } else if (ValueHelper.getEnglishValue(value) > maxValue) {
        value = maxValue;
      }
    }
    if (event.target.name === 'winnersBySelected' && value && value.id === 3) {
      winLimitEff = '';
    }
    if (event.target.name === 'winnersBySelected' && value && value.showWinnersByValue) {
      this.updateState({[event.target.name]: value, showValidationMsg: false, winnersByValue: 0});
    } else {
      this.updateState({
        [event.target.name]: value,
        rewardState: rewardStateEff, rewardsData: rewardsData,
        winLimit: winLimitEff, winGLimit: winGLimitEff,
        showValidationMsg: false
      });
    }
  };

  onCheckedNoVoucherCodes = (event) => {
    const {inReward} = this.state;
    inReward.noVoucherCodes = event.target.checked;
    if (!inReward.noVoucherCodes) {
      inReward.noVCodes = 0;
    }
    this.updateState({inReward: inReward, showValidationMsg: false});
  };

  getSubsRewardOptionsRadioView(nameId, value, index) {
    const {classes, app} = this.props;
    const {inReward} = this.state;

    const onClick = () => {
      const {inReward} = this.state;
      inReward.noVCodes = value;
      this.updateState({inReward: inReward});
    };
    const isSelected = inReward.noVCodes === value;
    const margin = index > 0 ? 12 : 0;
    return (
      <Button
        key={index}
        color={isSelected ? 'primary' : 'secondary'}
        size={'small'}
        variant={"outlined"}
        onClick={onClick}
        style={{marginRight: !app.isLTR ? margin : 0, marginLeft: app.isLTR ? margin : 0}}
        className={isSelected ? classes.selectedColorButton : classes.whiteSecondaryColorButton}
        startIcon={isSelected ? <ImageIcon src={require('src/images/ic_checked.png')} /> : null}>
        <FormattedMessage id={nameId} />
      </Button>
    );
  }

  onChangeForReward = (event) => {
    const {inReward} = this.state;
    let value = event.target.value;
    if (event.target.name === 'fee' || event.target.name === 'endInDay') {
      const maxValue = event.target.name === 'endInDay' ? 365 : constants.activity.VALUE_DEFAULT_MAX;
      value = ValueHelper.getDecimalValue(value);
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = 0;
      } else if (ValueHelper.getEnglishValue(value) > maxValue) {
        value = maxValue;
      }
    }
    inReward[event.target.name] = value;
    this.updateState({inReward: inReward, showValidationMsg: false});
  };

  toggleCopyReward = () => {
    const {activityData} = this.props;
    const newState = {inCopyReward: !this.state.inCopyReward};
    if (!activityData.rewardsFetched) {
      activityData.rewardsFetched = true;
      newState.inCopyRewardedLoading = true;
      this.fetchRewardsToCopy('', 0);
    } else {
      newState.inCopyRewardedLoading = false;
      newState.inCopyRewardSearch = '';
    }
    this.setState(newState, () => {
      if (this.refSelectRewardToCopy) {
        this.refSelectRewardToCopy.open();
      }
    });
  }

  onChangeRewardToCopySearch = (value) => {
    // if (value.length > 1) {
    //   this.setState({inCopyRewardSearch: value, inCopyRewardedLoading: true}, () => {
    //     this.fetchRewardsToCopy(value);
    //   });
    // } else {
      this.setState({inCopyRewardSearch: value});
    // }
  };

  onSelectRewardToCopy = (item) => {
    if (!item) {
      return;
    }
    const {inReward} = this.state;
    inReward.title = item.name;
    inReward.description = item.description;
    inReward.imageUrl = item.imageUrl;
    inReward.videoUrl = item.videoUrl;
    inReward.videoTUrl = item.videoTUrl;
    inReward.videoStreamUrl = item.videoStreamUrl;
    inReward.isImageDeleted = true;
    inReward.isVideoDeleted = true;
    if (inReward.videoUrl) {
      inReward.copyVideoUrl = inReward.videoUrl;
      inReward.copyVideoStreamUrl = inReward.videoStreamUrl;
    } else if (inReward.imageUrl) {
      inReward.copyImageUrl = inReward.imageUrl;
    }

    inReward.mediaUrl = inReward.videoUrl || (inReward.imageUrl && inReward.imageUrl != getActivityDefaultImageUrl(constants.activity.types.OFFER) ? inReward.imageUrl : null);
    inReward.mediaType = inReward.videoUrl || (inReward.videoFiles && inReward.videoFiles.length > 0) ? FILE_TYPE_VIDEO : FILE_TYPE_IMAGE;
    inReward.mediaTUrl = inReward.videoTUrl;
    inReward.initialMediaFiles = getInitialFiles(null, inReward.mediaUrl, inReward.mediaType, inReward.mediaTUrl);
    this.updateState({
      inReward: inReward,
      inCopyReward: false,
      inCopyRewardSearch: '',
      inCopyRewardedLoading: false,
      showValidationMsg: false,
    });
  };

  fetchRewardsToCopy = (value, delay = 200) => {
    if (this.clearTimeout) {
      clearTimeout(this.clearTimeout);
    }
    const _this = this;
    this.clearTimeout = setTimeout(() => {
      const {activityData} = this.props;
      const usageType = activityData.usageType === constants.activity.usageTypes.LOYALTY ? activityData.usageType : null;
      this.props.fetchActivityWinRewards(value, usageType).then(() => {
        this.updateState({inCopyRewardedLoading: false}, () => {
          if (!_this.props.activities.activity.data.winRewards || _this.props.activities.activity.data.winRewards.length === 0) {
            _this.props.activityData.noRewardsPresent = true;
            this.setState({inCopyReward: false});
          }
        });
      }).catch(() => {
        this.props.showSnackbar({
          messageId: 'activity.rewardsLoadingError',
          type: 'error'
        });
        _this.props.activityData.rewardsFetched = false;
        this.updateState({inCopyReward: false, inCopyRewardedLoading: false});
      });
    }, delay);
  }

}

ManageActivityRewards.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityRewards.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchActivityWinRewards: (search, usageType) => dispatch(fetchActivityWinRewards(search, usageType)),
    showSnackbar: (snackbar) => dispatch(showSnackbar(snackbar)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityRewards))
);
